export default __webpack_public_path__ + "static/media/fire.a492144a.svg";